import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { faqs } from '../../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-ink-950 py-12 sm:py-16" aria-labelledby="faq-title" data-id="element-135" data-mp="x53cyzs363aq">
      <div className="mx-auto w-full max-w-2xl px-4 sm:px-6" data-id="element-136" data-mp="123oc0vvlqgxl">
        <h2 id="faq-title" className="text-center font-display text-[1.75rem] font-extrabold uppercase leading-[1.02] text-white sm:text-4xl" data-id="element-137" data-mp="1pshcn5n65cyj">
          Frequently asked questions
        </h2>

        <ul className="mt-7 space-y-2.5" data-id="element-138" data-mp="1g3653nfxkgcr">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <li key={faq.q} className="overflow-hidden rounded-xl border border-white/10 bg-ink-900" data-id="element-139" data-mp="1kzo9unb9gep3" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-4 py-3.5 text-left transition-colors duration-150 ease-out hover:bg-white/[0.04] focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-400" data-id="element-140" data-mp="2dibl7b0ggfcz">
                  <span className="text-[15px] font-bold leading-snug text-white sm:text-base" data-id="element-141" data-mp="2tp1wrq7matzq">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-gold-500 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-142" data-mp="37it7v30zylxk" />
                </button>
                {isOpen && <p className="border-t border-white/10 px-4 py-3.5 text-sm leading-relaxed text-steel-300 sm:text-[15px]" data-id="element-143" data-mp="1n0lj7uvp1gc3">
                    {faq.a}
                  </p>}
              </li>;
        })}
        </ul>

        <div className="mx-auto mt-8 max-w-xl" data-id="element-144" data-mp="27riiixc8v2r9">
          <CTAButton label="I’m ready — give me access" sub="One-time $27 USD · 7-day guarantee" size="md" data-id="element-145" data-mp="2br9dld8t051l" />
        </div>
      </div>
    </section>;
}